export {
  type IllustrationPropsWithoutChildren,
  Illustration,
  type IllustrationProps
} from '../../../src/icon/Illustration';
